/**
 * localStorage persistence of the shopping cart, one entry per signed-in user.
 *
 * The cart used to live under one shared key, so it survived a logout and the next person signing in on the same
 * browser saw (and could check out) the previous person's cart. Now every user has their own key and logout removes
 * all of them. Deliberately free of imports, so `services/auth` can clear it without an import cycle.
 */

/** The old, user-independent key. Only ever removed. */
export const LEGACY_SHOPPING_CART_KEY = "ngft-shopping-cart-order";

const KEY_PREFIX = `${LEGACY_SHOPPING_CART_KEY}:`;

export const shoppingCartKey = (userId: string): string => `${KEY_PREFIX}${userId}`;

type StoredOrders = Record<string, unknown>;

export const readShoppingCart = (userId: string): StoredOrders => {
  try {
    return JSON.parse(localStorage.getItem(shoppingCartKey(userId)) as string) || {};
  } catch (e) {
    return {};
  }
};

export const writeShoppingCart = (userId: string, orders: StoredOrders): void => {
  try {
    localStorage.setItem(shoppingCartKey(userId), JSON.stringify(orders));
    localStorage.removeItem(LEGACY_SHOPPING_CART_KEY);
  } catch (e) {}
};

/** Removes every user's cart and the legacy shared one (called on logout). */
export const clearShoppingCarts = (): void => {
  try {
    const keys: string[] = [];
    for (let i = 0; i < localStorage.length; i++) {
      const key = localStorage.key(i);
      if (key === LEGACY_SHOPPING_CART_KEY || key?.startsWith(KEY_PREFIX)) {
        keys.push(key);
      }
    }
    keys.forEach((key) => localStorage.removeItem(key));
  } catch (e) {}
};
